import { Injectable } from '@angular/core';
import * as firebase from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() {}

  generateRandomName() {
    let text = '';
    const possible =
      'ASGSAFASSFAFSAFSAFASSFAASFSFEWRasvxxzfvdokeokepokpakaspkfposafepopokasw115165515236236232325150';
    for (let i = 0; i < 5; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  uploadFile(file) {
    const fileName = this.generateRandomName();
    const fileRef = firebase
      .storage()
      .ref()
      .child('image/' + fileName);
    const uploadTask = fileRef.put(file);
    return new Promise((resolve, reject) => {
      uploadTask.on(
        'state_changed',
        snapshot => {},
        error => {
          reject(error);
        },
        () => {
          const fileUrl = uploadTask.snapshot.downloadURL;
          resolve({ fileName, fileUrl });
        }
      );
    });
  }
  handleImageUpload(data, pacijentid) {
    const newPersonalImageKey = firebase
      .database()
      .ref()
      .child('images')
      .push().key;
    const personalImageDetails = {
      fileUrl: data.fileUrl,
      name: data.fileName,
      creationDate: new Date().toString()
    };
    const updates = {};
    updates[
      '/images/' + pacijentid + '/' + newPersonalImageKey
    ] = personalImageDetails;
    return firebase
      .database()
      .ref()
      .update(updates);
  }
  deleteImage(pacijentid, imageid) {
    return firebase
      .database()
      .ref('/images/' + pacijentid)
      .child(imageid)
      .remove();
  }
  createNaplata(naplata, doktor, datum, key) {
    firebase
      .database()
      .ref('/naplata/')
      .child(key)
      .set({ naplata, doktor, datum });
  }
}
